/**
 * Homepage Hero Carousel — V3A Lab only. Toggles hidden / is-active / aria-hidden.
 */
(function () {
  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function init(root) {
    var slides = Array.prototype.slice.call(
      root.querySelectorAll(".homepage-hero-carousel__slide")
    );
    if (!slides.length) return;

    var dots = Array.prototype.slice.call(
      root.querySelectorAll(".homepage-hero-carousel__dot")
    );
    var prev = root.querySelector(".homepage-hero-carousel__arrow--prev");
    var next = root.querySelector(".homepage-hero-carousel__arrow--next");
    var autoplay =
      root.dataset.autoplay === "true" && !prefersReducedMotion();
    var interval = parseInt(root.dataset.interval || "5500", 10);
    var index = slides.findIndex(function (s) {
      return s.classList.contains("is-active");
    });
    if (index < 0) index = 0;
    var timer = null;
    var touchX = 0;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (slide, idx) {
        var on = idx === index;
        slide.classList.toggle("is-active", on);
        slide.toggleAttribute("hidden", !on);
        slide.setAttribute("aria-hidden", on ? "false" : "true");
      });
      dots.forEach(function (dot, idx) {
        var on = idx === index;
        dot.classList.toggle("is-active", on);
        dot.setAttribute("aria-selected", on ? "true" : "false");
      });
    }

    function nextSlide() {
      show(index + 1);
    }

    function prevSlide() {
      show(index - 1);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (autoplay && slides.length > 1) timer = setInterval(nextSlide, interval);
    }

    if (prev) prev.addEventListener("click", function () { prevSlide(); start(); });
    if (next) next.addEventListener("click", function () { nextSlide(); start(); });
    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        show(parseInt(dot.dataset.index || "0", 10));
        start();
      });
    });

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);
    root.addEventListener("focusin", stop);
    root.addEventListener("focusout", function (e) {
      if (!root.contains(e.relatedTarget)) start();
    });

    root.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") {
        e.preventDefault();
        prevSlide();
      } else if (e.key === "ArrowRight") {
        e.preventDefault();
        nextSlide();
      }
    });

    root.addEventListener(
      "touchstart",
      function (e) {
        touchX = e.changedTouches[0].screenX;
      },
      { passive: true }
    );
    root.addEventListener(
      "touchend",
      function (e) {
        var dx = e.changedTouches[0].screenX - touchX;
        if (Math.abs(dx) < 40) return;
        if (dx < 0) nextSlide();
        else prevSlide();
        start();
      },
      { passive: true }
    );

    show(index);
    start();
  }

  function boot() {
    document
      .querySelectorAll(".homepage-hero-carousel__region")
      .forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
